import React, {Component} from 'react';
import MaterialIcon from '../../MaterialIcon';
import {showToastForFrontend} from "../../../actions/toastActions";
import messageCodes from "../../../utils/messageCodes";
import {connect} from "react-redux";
import {addContextPropertyToRetrieve, removeContextPropertyToRetrieve} from "../../../actions/contextPropertiesToRetrieveActions";
import {addAttributeToRetrieve, removeAttributeToRetrieve} from "../../../actions/attributesToRetrieveActions";


/*
*   Props:
*     contextPropsToRetrieve: Array
*        name: String
*        addedByUpdater: Boolean
*     appributesToRetrieve: Array
*        name: String
*        addedByUpdater: Boolean
 */
class PropertiesToRetrieveTab extends Component {

    constructor(props) {
        super(props);

        this.state = {
            attributeName: "",
            propertyName: ""
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.deleteAttributes = this.deleteAttributes.bind(this);
        this.addAttribute = this.addAttribute.bind(this);
        this.deleteContextProps = this.deleteContextProps.bind(this);
        this.addContextProp = this.addContextProp.bind(this);
    }

    handleInputChange(e, fieldName) {
        let update = e.target.value || "";
        let updateParam = {};
        if (fieldName === "attributeName" || fieldName === "propertyName") {
            update = update.replace(/\s/g, '')
        }
        updateParam[fieldName] = update;

        this.setState({
            ...updateParam
        });
    }

    addContextProp() {
        if (this.validatePropertyFields()) {
            const newContextProp = this.state.propertyName;

            this.props.addContextPropertyToRetrieve(newContextProp);

            this.setState({
                propertyName: "",
            })
        } else {
            this.props.showToastForFrontend(messageCodes.SAMPLE_WARNING)
        }


    }

    deleteContextProps(deleteIndex) {
        const toBeDeletedContextProp = this.props.contextPropsToRetrieve[deleteIndex];
        this.props.removeContextPropertyToRetrieve(toBeDeletedContextProp);
    }

    validatePropertyFields() {
        if (this.state.propertyName.length < 1)
            return false;
        if (this.props.contextPropsToRetrieve.some((prop) => prop.name === this.state.propertyName))
            return false;

        return true;
    }

    addAttribute() {
        if (this.validateAttributeFields()) {
            const newAttribute = this.state.attributeName;

            this.props.addAttributeToRetrieve(newAttribute);

            this.setState({
                attributeName: "",
            })
        } else {
            this.props.showToastForFrontend(messageCodes.SAMPLE_WARNING)
        }


    }

    deleteAttributes(deleteIndex) {
        const toBeDeletedAttribute = this.props.attributesToRetrieve[deleteIndex];
        this.props.removeAttributeToRetrieve(toBeDeletedAttribute);
    }

    validateAttributeFields() {
        if (this.state.attributeName.length < 1)
            return false;
        if (this.props.attributesToRetrieve.some((prop) => prop.name === this.state.attributeName))
            return false;

        return true;
    }


    render() {
        return (
                <>
                    <div className="context-property-to-retrieve-tab">
                        <div className="context-property-to-retrieve-title">
                            <label className="checkbox-wrapper">
                                Attributes to retrieve
                            </label>
                        </div>
                        <div className="context-property-to-retrieve-form">
                            <input className="panel-input" type="text" name="attributeName" placeholder="Name"
                                        value={this.state.attributeName} onChange={(e) => this.handleInputChange(e, "attributeName")} />
                            <div className="add-property" onClick={this.addAttribute}><MaterialIcon icon="add_circle" />Add
                                Attribute
                            </div>
                        </div>

                        <div className="context-property-to-retrieve-table">
                            <table className={"table"}>
                                <thead>
                                    <tr>
                                        <th>
                                            Name
                                        </th>
                                        <th>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.attributesToRetrieve && this.props.attributesToRetrieve.map((attribute, index) => (
                                        <tr key={attribute}>
                                            <td>{attribute}</td>
                                            <td>
                                                <MaterialIcon icon="close" onClick={() => this.deleteAttributes(index)} />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="context-property-to-retrieve-tab">
                        <div className="context-property-to-retrieve-title">
                            <label className="checkbox-wrapper">
                                Context properties to retrieve
                            </label>
                        </div>
                        <div className="context-property-to-retrieve-form">
                            <input className="panel-input" type="text" name="propertyName" placeholder="Name"
                                value={this.state.propertyName} onChange={(e) => this.handleInputChange(e, "propertyName")} />
                            <div className="add-property" onClick={this.addContextProp}><MaterialIcon icon="add_circle" />Add
                                Property
                            </div>
                        </div>

                        <div className="context-property-to-retrieve-table">
                            <table className={"table"}>
                                <thead>
                                    <tr>
                                        <th>
                                            Name
                                        </th>
                                        <th>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.contextPropsToRetrieve && this.props.contextPropsToRetrieve.map((contextProp, index) => (
                                            <tr key={contextProp}>
                                                <td>{contextProp}</td>
                                                <td>
                                                    <MaterialIcon icon="close" onClick={() => this.deleteContextProps(index)} />
                                                </td>
                                            </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
        );
    }
}

function mapStateToProps(state) {
    return {
        contextPropsToRetrieve: state.contextPropertiesToRetrieve,
        attributesToRetrieve: state.attributesToRetrieve
    }
}

export default connect(mapStateToProps, {
    showToastForFrontend,
    addAttributeToRetrieve,
    removeAttributeToRetrieve,
    addContextPropertyToRetrieve,
    removeContextPropertyToRetrieve,
})(PropertiesToRetrieveTab);